import { RoleTitles } from "views/settings-users/slices/users/constants";
import { SplitApplicationActivity } from "../types";
import { Button, ButtonSize, ButtonVariant, Show } from "shared/components";
import { getApplicantsText, getOriginalApplicantsText } from "../helpers";
import { Link } from "react-router-dom";

interface ApplicationSplitProps {
  activityItem: SplitApplicationActivity;
}

export const ApplicationSplit = ({ activityItem }: ApplicationSplitProps) => {
  if (
    !["split_application", "created_from_split"].includes(
      activityItem.activity_type
    ) ||
    typeof activityItem.details !== "object" ||
    !activityItem.details.original_application_id ||
    !activityItem.details.split_application_id
  )
    return null;

  return (
    <div className="space-y-2">
      <div>
        <p className="text-base font-bold text-content-1000">
          Application was{" "}
          {activityItem.activity_type === "created_from_split"
            ? "split from another group"
            : "split"}
        </p>
      </div>
      <div>
        {activityItem.author?.name ? (
          <p className="text-sm font-normal text-content-400">
            by {activityItem.author.name} (
            {RoleTitles[activityItem.author.author_role] || "--"})
          </p>
        ) : null}
        <Show if={activityItem.activity_type === "split_application"}>
          <p className="text-sm font-normal text-content-400">
            Original application group:{" "}
            {getOriginalApplicantsText(
              activityItem as SplitApplicationActivity
            )}
          </p>
        </Show>
        {activityItem.details.original_application_id ? (
          <div>
            <p className="text-sm font-normal text-content-400">
              {activityItem.activity_type === "created_from_split"
                ? "Split from: "
                : "Split to: "}
              {getApplicantsText(
                activityItem.activity_type === "created_from_split"
                  ? activityItem.details.remaining_applicants
                  : activityItem.details.moving_applicants
              )}
            </p>
          </div>
        ) : null}
      </div>
      {activityItem.details.original_application_id ? (
        <div>
          <Link
            to={`/applications/${activityItem.activity_type === "created_from_split" ? activityItem.details.original_application_id : activityItem.details.split_application_id}`}
          >
            <Button variant={ButtonVariant.TEXT} size={ButtonSize.SM}>
              {activityItem.activity_type === "created_from_split"
                ? "Link to the original application group"
                : "Link to the new application group"}
            </Button>
          </Link>
        </div>
      ) : null}
    </div>
  );
};
